import { environment } from "../../../../../../environments/environment";
import { ConnectAppInterface } from "../../../../../shared/interfaces/connect-apps";
import { AppType } from "../enums/enums";

export const apps: ConnectAppInterface[] = [
  {
    title: "ConnectAppsInfo.Core",
    subtitle: "IDenedi",
    description: "ConnectAppsInfo.CoreDesc",
    key: AppType.Core,
    metaData: {
      canAdd: false,
      canDisconnect: false,
    }
  },
  {
    title: "ConnectAppsInfo.NotificationService",
    subtitle: "Notification Service",
    description: "ConnectAppsInfo.NotificationServiceDesc",
    key: AppType.NotificationService,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      hasDefaultConnection: true,
      canUpdateLogin: true,
      defaultLoginCredentials: {
        apiUrl: environment.production ? 'https://stemexenotificationservice.azurewebsites.net/' : `https://notificationservice-testing.azurewebsites.net/`,
        username: environment.production ? 'GtU6Uc01y676' : 'GtU6Uc01y676',
        password: environment.production ? 'yhSL29kCUNPeY4gfVxSBmsym' : 'yhSL29kCUNPeY4gfVxSBmsym'
      }
    }
  },
  {
    title: "ConnectAppsInfo.DigitalLibrary",
    subtitle: "Technadopt",
    description: "ConnectAppsInfo.DigitalLibraryDesc",
    key: AppType.Technadopt,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      hasDefaultConnection: true,
      canUpdateLogin: false,
      dialogTitle: `Connect to Technadopt Application`,
      dialogBody: `You have the option to create new deployment or connect to existing one.`,
      defaultLoginCredentials: {
        apiUrl: environment.production ? '' : `${environment.technadoptApiHost}`,
        username: environment.production ? '' : "technadopt@ciklum.com",
        password: environment.production ? '' : "Admin@1952"
      }

    }
  },
  {
    title: "ConnectAppsInfo.KPIs&Activities",
    subtitle: "SimpleStrata",
    description: "ConnectAppsInfo.KPIs&ActivitiesDesc",
    key: AppType.SimpleStrata,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      hasDefaultConnection: true,
      canUpdateLogin: false,
      defaultLoginCredentials: {
        apiUrl: environment.production ? '' : 'https://ss-staging-gateway.azurewebsites.net',
        username: environment.production ? '' : 'alishd@mailinator.com',
        password: environment.production ? '' : 'P@ssw0rd'
      }

    }
  },
  {
    title: "ConnectAppsInfo.AutomatedProcesses",
    subtitle: "ESP",
    description: "ConnectAppsInfo.AutomatedProcessesDesc",
    key: AppType.ESP,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      hasDefaultConnection: true,
      canUpdateLogin: false,
      defaultLoginCredentials: {
        apiUrl: environment.production ? '' : `https://qaesp.azurewebsites.net`,
        username: environment.production ? '' : 'muhammadsai@mailinator.com',
        password: environment.production ? '' : 'aaaaaa'
      }

    }
  },
  {
    title: "ConnectAppsInfo.Projects",
    subtitle: "Plannexe",
    description: "ConnectAppsInfo.ProjectsDesc",
    key: AppType.EngagementPro,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      hasDefaultConnection: true,
      canUpdateLogin: true,
      defaultLoginCredentials: {
        apiUrl: environment.production ? 'https://plannexe.exceeders.com/' : 'https://engpro2dev.azurewebsites.net/',
        username: environment.production ? '' : '',
        password: environment.production ? '' : ''
      }

    }
  },
  {
    title: "ConnectAppsInfo.Opportunities",
    subtitle: "Opportunity Pro",
    description: "ConnectAppsInfo.OpportunitiesDesc",
    key: AppType.OppPro,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      hasDefaultConnection: false,
      canUpdateLogin: true,
      defaultLoginCredentials: {
        apiUrl: environment.production ? '' : 'https://oppprodev.azurewebsites.net/',
        username: environment.production ? '' : '',
        password: environment.production ? '' : ''
      }

    }
  },
  {
    title: "ConnectAppsInfo.CustomMeetingScheduler",
    subtitle: "Office 365",
    description: "ConnectAppsInfo.CustomMeetingSchedulerDesc",
    key: AppType.Office365,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      canUpdateLogin: true,
      hasDefaultConnection: false
    }
  },
  {
    title: "ConnectAppsInfo.Analytics",
    subtitle: "Power BI",
    description: "ConnectAppsInfo.AnalyticsDesc",
    key: AppType.PowerBi,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      canUpdateLogin: true,
      hasDefaultConnection: false
    }
  },
  {
    title: "ConnectAppsInfo.Tutorials",
    subtitle: "Intajy",
    description: "ConnectAppsInfo.TutorialsDesc",
    key: AppType.Intajy,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      canUpdateLogin: true,
      hasDefaultConnection: false,
      defaultLoginCredentials: {
        apiUrl: environment.production ? '' : 'https://exceeders.meetexe.com',
        username: environment.production ? '' : "ahmad@exceeders.com",
        password: environment.production ? '' : "9DuWHjh3eHbrwfP"
      }
    }
  },
  {
    title: "ConnectAppsInfo.Vacancies",
    subtitle: "Higher",
    description: "ConnectAppsInfo.VacanciesDesc",
    key: AppType.Higher,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      hasDefaultConnection: false,
      canUpdateLogin: true,
      defaultLoginCredentials: {
        apiUrl: environment.production ? '' : `${environment.higherBaseURL}`,
        username: environment.production ? '' : "higheruser@mailinator.com",
        password: environment.production ? '' : "higher@exceed"
      }

    }
  },
  {
    title: "ConnectAppsInfo.ChatBot",
    subtitle: "Microsoft",
    description: "ConnectAppsInfo.ChatBotDesc",
    key: AppType.ChatBot,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: true,
      canUpdateLogin: true,
      hasDefaultConnection: false

    }
  },
  {
    title: "ConnectAppsInfo.TrafficAnalytics",
    subtitle: "Google Analytics",
    description: "ConnectAppsInfo.TrafficAnalyticsDesc",
    key: AppType.GoogleAnalytics,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      canUpdateLogin: true,
      hasDefaultConnection: false

    }
  },
  {
    title: "ConnectAppsInfo.VirtualRoom",
    subtitle: "ConnecteXe",
    description: "ConnectAppsInfo.VirtualRoomDesc",
    key: AppType.VirtualRoom,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      canUpdateLogin: false,
      hasDefaultConnection: true,
      defaultLoginCredentials: {
        apiUrl: environment.production ? '' : `https://room.meetexe.com`,
        username: environment.production ? '' : '',
        password: environment.production ? '' : ''
      }
    }
  },
  {
    title: "ConnectAppsInfo.LeadLine",
    subtitle: "Leadline",
    description: "ConnectAppsInfo.LeadLineDesc",
    key: AppType.LeadLine,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      hasDefaultConnection: false,
      canUpdateLogin: false,
      defaultLoginCredentials: {
        apiUrl: environment.production ? '' : 'https://oppprodevapi.azurewebsites.net',
        username: environment.production ? '' : 'Syed.Ahmed_@LeadLine',
        password: environment.production ? '' : '123456'
      }

    }
  },
  {
    title: "ConnectAppsInfo.Tilda",
    subtitle: "Tilda",
    description: "ConnectAppsInfo.TildaDesc",
    key: AppType.Tilda,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      hasDefaultConnection: false,
      canUpdateLogin: false
    }
  },
  {
    title: "ConnectAppsInfo.GlobalSearch",
    subtitle: "Search",
    description: "ConnectAppsInfo.GlobalSearchDesc",
    key: AppType.GlobalSearch,
    metaData: {
      canAdd: true,
      canDisconnect: true,
      canAddMultiple: false,
      canUpdateLogin: false,
      hasDefaultConnection: false,
      defaultLoginCredentials: {
        apiUrl: `${environment.aimeetexeApiUrl}`,
        username: environment.production ? '' : '',
        password: environment.production ? '' : ''
      }
    }
  },
];